import React from 'react'
import { Output } from 'Components/common/form'
import { Columns, Column, Box } from 'Components/common/bulma'


const Perfil = ({data}) => {
    return (
        <Box>
            <Columns>
                <Column>
                    <Output
                        {...data.id}
                    />
                </Column>
                <Column>
                    <Output
                        {...data.nombreRazonSocial }
                    />
                </Column>

            </Columns>
            <Columns>
                <Column>
                    <Output
                        {...data.cuentaClabeStp}
                    />
                </Column>
                <Column>
                    <Output
                        {...data.pagosReferenciados}
                    />
                </Column>
            </Columns>
            <Columns>
                <Column>
                    <Output
                        {...data.cuentaMXN}
                    />
                </Column>
                <Column>
                    <Output
                        {...data.cuentaUSD}
                    />
                </Column>
            </Columns>
        </Box>
    );
};

export default Perfil;